export default `
mutation CreatePropertyEvent(
  $eventId: String,
  $icon: String!, 
  $text: String!, 
  $senderName: String!, 
  $senderId: String!,
  $propertyId: String!, 
  $serviceProviderId: String!, 
  $instanceId: String!
) {
  createPropertyEvent (
    eventId: $eventId, 
    icon: $icon, 
    text: $text, 
    senderName: $senderName, 
    senderId: $senderId, 
    propertyId: $propertyId, 
    serviceProviderId: $serviceProviderId, 
    instanceId: $instanceId
  ) {
    icon
    text
    eventId
    senderId 
    createdAt
    instanceId
    senderName
    propertyId
    serviceProviderId
  }
}
`;